export const COMPLIANCE_DATA = {
  legalName: "Kredere Family Office Private Limited",
  tradeName: "Kredere Family Office",
  arn: "164680",
  arnValidity: "01-01-2027",
  euin: null,
  sifEnabled: true,
  address: "905-906, Raheja Chambers, Free Press Journal Marg, Nariman Point, Mumbai - 400021",
  contactEmail: "info@kredere.com",
  contactPhone: "+91 22 43490400",
  grievanceEmail: "info@kredere.com",
  grievanceOfficer: null,
  scoresLink: "https://scores.gov.in"
};

export const STANDARD_RISK_WARNING = "Mutual Fund investments are subject to market risks, read all scheme related documents carefully.";

export const TAGLINE_MF = "AMFI-registered Mutual Fund Distributor";
export const TAGLINE_SIF = "AMFI Registered SIF Distributor";

export const SIF_MIN_INVESTMENT = "₹10,00,000";

export const OFFICE_HOURS = "Monday - Friday: 9:30 AM - 6:00 PM IST";
export const RESPONSE_TIME = "We aim to respond to all inquiries within 1-2 business days.";